export default __webpack_public_path__ + "static/media/Trips.13260006.svg";